export function Brand({ dark = false, slogan, tag = true }: { dark?: boolean; slogan?: string; tag?: boolean }) {
  return (
    <div className={`brand${dark ? ' on-dark' : ''}${slogan ? ' hero-brand' : ''}`} aria-label="DisploraQ">
      <div className="word">Displora<span className="q">Q</span></div>
      {slogan ? <div className="slogan">{slogan}</div> : tag ? <div className="tag">SMART DIGITAL SIGNAGE</div> : null}
    </div>
  );
}
